import {
  Dashboard as DashboardIcon,
  Work as WorkIcon,
  Assessment as AssessmentIcon,
  Folder as FolderIcon,
  Description as DescriptionIcon,
  AdminPanelSettings as AdminPanelSettingsIcon,
  SupervisorAccount as SupervisorAccountIcon,
  MonitorHeart as MonitorHeartIcon,
  History as HistoryIcon,
  RateReview as RateReviewIcon,
  VerifiedUser as VerifiedUserIcon,
  AttachMoney as AttachMoneyIcon,
  Email as EmailIcon,
  Error as ErrorIcon,
  HowToReg as HowToRegIcon,
  AccountBalance as AccountBalanceIcon,
  Group as GroupIcon,
  Settings as SettingsIcon,
  CalendarMonth as CalendarMonthIcon,
  Class,
  Gavel as GavelIcon,
  Payments as PaymentsIcon,
  PriceCheck as PriceCheckIcon,
  Build as BuildIcon,
  ReceiptLong as ReceiptLongIcon,
  Star as StarIcon,
  Map as MapIcon,
  FilterList as FilterListIcon,
  HelpOutline as HelpOutlineIcon,
  Notifications as NotificationsIcon,
  BarChart as BarChartIcon,
  Business as BusinessIcon,
  QrCode as QrCodeIcon,
  ViewKanban as ViewKanbanIcon,
  People as PeopleIcon,
  RequestQuote as RequestQuoteIcon,
  WorkOutline as WorkOutlineIcon,
  Palette as PaletteIcon,
  Tune as TuneIcon,
  Sync as SyncIcon,
  BugReport as BugReportIcon,
  Receipt as ReceiptIcon,
  Security as SecurityIcon,
  AccountTree as AccountTreeIcon,
  AddCard as AddCardIcon,
  TaskAlt as TaskAltIcon,
  Newspaper as NewspaperIcon,
  MoneyOff as MoneyOffIcon,
  Sms as SmsIcon,
  LocationOn as LocationOnIcon,
  LocalShipping as LocalShippingIcon,
  SmartToy as SmartToyIcon,
  TrendingUp as TrendingUpIcon,
  AccessTime as AccessTimeIcon,
  Campaign as CampaignIcon,
} from '@mui/icons-material';
import { navigationIcons } from '../../lib/roles';

// Icon mapping for dynamic icon rendering - streamlined to working navigation only
export const iconMap = {
  CampaignIcon: CampaignIcon,
  DashboardIcon: DashboardIcon,
  AccessTimeIcon: AccessTimeIcon,
  WorkIcon: WorkIcon,
  AssessmentIcon: AssessmentIcon,
  FolderIcon: FolderIcon,
  DescriptionIcon: DescriptionIcon,
  AdminPanelSettingsIcon: AdminPanelSettingsIcon,
  SupervisorAccountIcon: SupervisorAccountIcon,
  MonitorHeartIcon: MonitorHeartIcon,
  HistoryIcon: HistoryIcon,
  RateReviewIcon: RateReviewIcon,
  VerifiedUserIcon: VerifiedUserIcon,
  AttachMoneyIcon: AttachMoneyIcon,
  EmailIcon: EmailIcon,
  ErrorIcon: ErrorIcon,
  HowToRegIcon: HowToRegIcon,
  AccountBalanceIcon: AccountBalanceIcon,
  GroupIcon: GroupIcon,
  SettingsIcon: SettingsIcon,
  CalendarMonthIcon: CalendarMonthIcon,
  CategoryIcon: Class,
  GavelIcon: GavelIcon,
  PaymentsIcon: PaymentsIcon,
  PriceCheckIcon: PriceCheckIcon,
  BuildIcon: BuildIcon,
  ReceiptLongIcon: ReceiptLongIcon,
  StarIcon: StarIcon,
  MapIcon: MapIcon,
  FilterListIcon: FilterListIcon,
  HelpOutlineIcon: HelpOutlineIcon,
  NotificationsIcon: NotificationsIcon,
  BarChartIcon: BarChartIcon,
  BusinessIcon: BusinessIcon,
  QrCodeIcon: QrCodeIcon,
  ViewKanbanIcon: ViewKanbanIcon,
  PeopleIcon: PeopleIcon,
  RequestQuoteIcon: RequestQuoteIcon,
  WorkOutlineIcon: WorkOutlineIcon,
  PaletteIcon: PaletteIcon,
  TuneIcon: TuneIcon,
  SyncIcon: SyncIcon,
  BugReportIcon: BugReportIcon,
  ReceiptIcon: ReceiptIcon,
  SecurityIcon: SecurityIcon,
  AccountTreeIcon: AccountTreeIcon,
  AddCardIcon: AddCardIcon,
  TaskAltIcon: TaskAltIcon,
  NewspaperIcon: NewspaperIcon,
  MoneyOffIcon: MoneyOffIcon,
  SmsIcon: SmsIcon,
  LocationOnIcon: LocationOnIcon,
  LocalShippingIcon: LocalShippingIcon,
  SmartToyIcon: SmartToyIcon,
  TrendingUpIcon: TrendingUpIcon,
};

// Get icon component for a navigation item
export const getIconComponent = (label: string) => {
  const iconName = navigationIcons[label as keyof typeof navigationIcons];
  const IconComponent = iconMap[iconName as keyof typeof iconMap];
  return IconComponent ? <IconComponent fontSize="small" /> : null;
};

// Get icon for an admin category
export const getCategoryIcon = (category: string) => {
  switch (category) {
    case 'users':
      return <SupervisorAccountIcon fontSize="small" />;
    case 'content':
      return <Class fontSize="small" />;
    case 'logistics':
      return <LocalShippingIcon fontSize="small" />;
    case 'compliance':
      return <VerifiedUserIcon fontSize="small" />;
    case 'finance':
      return <AttachMoneyIcon fontSize="small" />;
    case 'system':
      return <MonitorHeartIcon fontSize="small" />;
    default:
      return <AdminPanelSettingsIcon fontSize="small" />;
  }
};
